import Axios from "../../Config/API";

import {
    IEquipe,
    ICadastroEquipe,
} from "../../../Interfaces/HelpDesk/Equipes/EquipeInterface";
import Service from "../../Service";

export async function ListarEquipesServices() {
    return Service(
        Axios.get<Array<IEquipe>>(
            `/helpdesk/gestaodeequipeshelpdesk/listarequipehelpdesk`
        )
    );
}

export async function AtualizarEquipeService(requestBody: IEquipe) {
    return Service(
        Axios.put(
            `/helpdesk/gestaodeequipeshelpdesk/atualizarequipehelpdesk`,
            requestBody
        )
    );
}

export async function DeletarEquipeService(ID_FILA: number) {
    return Service(
        Axios.delete(
            `/helpdesk/gestaodeequipeshelpdesk/deletarequipehelpdesk?IdEquipe=${ID_FILA}`
        )
    );
}

export async function CadastrarEquipeService(requestBody: ICadastroEquipe) {
    requestBody.FL_ATIVO = true;
    return Service(
        Axios.post(
            `/helpdesk/gestaodeequipeshelpdesk/cadastrarequipehelpdesk`,
            requestBody
        )
    );
}

export async function GetEquipeService(ID_FILA: number) {
    return Service(
        Axios.get<IEquipe>(
            `/helpdesk/gestaodeequipeshelpdesk/getequipehelpdesk?IdEquipe=${ID_FILA}`
        )
    );
}

export async function GetEquipeUsuarioService() {
    return Service(
        Axios.get<IEquipe>(
            `/helpdesk/gestaodeequipeshelpdesk/getequipeusuariohelpdesk`
        )
    );
}
